module.exports = __webpack_public_path__ + "static/media/level-two.7ffc1c01.svg";